import React from 'react';
import PropTypes from 'prop-types';
import { getLocator, getPromotionalMessage, isCanada } from '../../../../../utils';
import RichText from '../../../../common/atoms/RichText';
import { getFormattedLoyaltyText } from '../../ProductListing/molecules/ProductList/utils/productsCommonUtils';
import PromotionalMsgContainer from './styles/PromotionalMessage.style';

function PromotionalMessage(props) {
  const {
    isPlcc,
    isInternationalShipping,
    compactView,
    promotionalMessage,
    promotionalPLCCMessage,
  } = props;
  if (compactView) return null;
  const text = getPromotionalMessage(isPlcc, {
    promotionalMessage,
    promotionalPLCCMessage,
  });

  return text && !isInternationalShipping && !isCanada() ? (
    <PromotionalMsgContainer data-locator={getLocator('global_loyalty_text')} isPlcc={isPlcc}>
      {text && (
        <RichText
          className="rewards__benefits multiline-ellipsis"
          richTextHtml={getFormattedLoyaltyText(text)}
        />
      )}
    </PromotionalMsgContainer>
  ) : null;
}

PromotionalMessage.propTypes = {
  isPlcc: PropTypes.bool,
  isInternationalShipping: PropTypes.bool.isRequired,
  promotionalMessage: PropTypes.string.isRequired,
  promotionalPLCCMessage: PropTypes.string.isRequired,
};
PromotionalMessage.defaultProps = {
  isPlcc: false,
};

export default PromotionalMessage;
